export default "__VITE_ASSET__Cm4oWX5b__"